import { Divider } from '@mui/material'
import { withStyles } from '@mui/styles'

const StyledDivider = withStyles({
    root: {
        color: '#757575'
    }
  })(Divider);

  export default StyledDivider